import { isValuePresent } from 'helpers/utils';
import { type FC, type MouseEvent, useState } from 'react';
import { ToggleButtonsGroup } from '../ToggleButtonsGroup';
import type { MultiselectCheckboxesProps } from './MultiselectCheckboxes.types';

const MultiselectCheckboxes: FC<MultiselectCheckboxesProps> = ({
  options,
  isReadOnly,
  onChange,
  separator = '|',
  initialValue = '',
  testPrefix,
  id,
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(
    isValuePresent(initialValue) ? initialValue?.split(separator) : [],
  );

  const handleChange = (_: MouseEvent<HTMLElement>, newValues: string[]) => {
    setSelectedValues(newValues);
    onChange?.(newValues.join(separator));
  };

  return (
    <ToggleButtonsGroup
      options={options.map((option) => ({ value: option.code, label: option.name }))}
      onChange={handleChange}
      value={selectedValues}
      isReadOnly={isReadOnly}
      inputVariant="checkbox"
      testPrefix={testPrefix}
      id={id}
    />
  );
};

export default MultiselectCheckboxes;
